// utils/downloadTakedownLogsExcel.ts

import { ReleaseTakedownLog } from "../../../../../types"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

const boolToText = (value?: boolean) => (value ? "Yes" : "No")

const buildRow = (log: ReleaseTakedownLog) => ({
  id: log.id ?? "",
  release: log.release?.title ?? "",
  upc: log.release?.upc ?? "",
  status: log.status ?? "",
  kahuna_spotify_url: log.spotifyId ? `https://open.spotify.com/album/${log.spotifyId}` : "",
  kahuna_apple_url: log.appleId ? `https://music.apple.com/us/album/${log.appleId}` : "",
  kahuna_youtube_url: log.youtubeId ? `https://www.youtube.com/watch?v=${log.youtubeId}` : "",
  spotify_link_ids: log.linkedSpotifyIds ?? "",
  apple_link_ids: log.linkedAppleIds ?? "",
  youtube_link_ids: log.linkedYoutubeIds ?? "",
  spotify_links: log.spotifyLinkCount ?? 0,
  spotify_visible: boolToText(log.spotifyVisible),
  spotify_complete: boolToText(log.spotifyComplete),
  spotify_split: boolToText(log.spotifySplitExist),
  apple_links: log.appleLinkCount ?? 0,
  apple_visible: boolToText(log.appleVisible),
  apple_complete: boolToText(log.appleComplete),
  youtube_links: log.youtubeLinkCount ?? 0,
  youtube_visible: boolToText(log.youtubeVisible),
  youtube_complete: boolToText(log.youtubeComplete),
  stream_weekly: log.streamWeekly,
  royalty_weekly: log.royaltyWeekly
})

export async function exportTakedownLogs(
  releaseTakedownLogList: ReleaseTakedownLog[],
  filename = "takedown_logs.xlsx"
) {
  if (!releaseTakedownLogList.length) return

  const rows = releaseTakedownLogList.map(buildRow)

  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet("Takedown Logs")

  const headers = Object.keys(rows[0])
  const headerRow = sheet.addRow(headers.map((h) => h.replaceAll("_", " ").toUpperCase()))
  headerRow.font = { bold: true }

  rows.forEach((row) => {
    sheet.addRow(headers.map((h) => (row as Record<string, any>)[h]))
  })

  sheet.columns.forEach((col) => {
    col.width = 18
  })

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  })

  saveAs(blob, filename)
}
